import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tool-kit',
  templateUrl: './tool-kit.component.html',
  styleUrls: ['./tool-kit.component.scss']
})
export class ToolKitComponent implements OnInit {

  @Input() hiddenTools: string[] = [];

  constructor() { }

  ngOnInit(): void {
  }

}
